import styled from 'styled-components';
import { themeGet } from 'modules/v2';
import { ListItem } from '../../List';
export const StyledListItem = styled(ListItem) `
  ${({ $noHoverEffect }) => $noHoverEffect &&
    `
    &:hover:not(:disabled) {
      cursor: default;
      user-select: auto;
      background-color: transparent;
    }
  `}
  padding: ${themeGet('spacing.md')};
`;
export const AvatarWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
